import {
  MenuComponent,
  ScrollComponent,
  StickyComponent,
  ToggleComponent,
  SwapperComponent,
} from "@/assets/js/components";

/**
 * Initialize KeenThemes custom components
 */
setTimeout(() => {
  ToggleComponent.bootstrap();
  StickyComponent.bootstrap();
  MenuComponent.bootstrap();
  ScrollComponent.bootstrap();
  SwapperComponent.bootstrap();
}, 500);
